import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FormatToHour',
  standalone: true  
})
export class DateHourPipe implements PipeTransform {

  transform(tiempoDecimal: number): string {

    if (tiempoDecimal == null || isNaN(tiempoDecimal)) {
      return '--:--:--';
    }
    // Calcular horas, minutos y segundos
    const horas = Math.floor(tiempoDecimal);
    const minutos = Math.floor((tiempoDecimal - horas) * 60);
    const segundos = Math.round(((tiempoDecimal - horas) * 60 - minutos) * 60);

    // Usar padStart para asegurar que siempre tenga 2 dígitos
    const horasFormateadas = String(horas).padStart(2, '0');
    const minutosFormateados = String(minutos).padStart(2, '0');
    const segundosFormateados = String(segundos).padStart(2, '0');

    // Devolver el tiempo en formato de "00:00:00"
    return `${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
  }

}
